import type { StyleSystemProps } from '@withjoy/joykit';
import { styled, Flex } from '@withjoy/joykit';
export const StyledGoBackWrapper = styled(Flex)``;
const goBackWrapperStyles: StyleSystemProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 'docked',
};

export const styles = {
  goBackWrapper: goBackWrapperStyles,
};
